import { ExistingPaymentMethod, SavedBank } from '~api/transaction/types';

export function isSavedBank(
  item: ExistingPaymentMethod | SavedBank,
): item is SavedBank {
  return (item as SavedBank).bankId !== undefined;
}
